import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=98ae9f12&scoped=true&"
import script from "./colors.vue?vue&type=script&lang=js&"
export * from "./colors.vue?vue&type=script&lang=js&"
import style0 from "./colors.vue?vue&type=style&index=0&id=98ae9f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ae9f12",
  null
  
)

export default component.exports